module.exports = __webpack_public_path__ + "static/media/feature_auto_learning.b1d09a1d.png";